import { TopN } from '../components/TopN'
import { ColumnComponent } from '../table_component'

export const dbtimeData = [
  {
    info: `DB Time Breakdown by multiple dimensions is just an estimation. There is possibility that it can print with more than 100%`
  }
]

interface DBTimeBySQLTypeData {
  sql_type: string
  mean: string | ColumnComponent
}

export const dbtimeBySQLTypeData: DBTimeBySQLTypeData[] = [
  {
    sql_type: 'Database Time',
    mean: 'Database_time:total.values.mean'
  },
  {
    sql_type: 'SQL Type(Top 5)',
    mean: { __component__: TopN(5, 'Database_time:by_type', ['proportion']) }
  }
]

interface DBTimeBySQLPhaseData {
  sql_phase: string
  mean: string
  proportion: string
}

export const dbtimeBySQLPhaseData: DBTimeBySQLPhaseData[] = [
  {
    sql_phase: 'Database Time',
    mean: 'Database_time:total.values.mean',
    proportion: 'NA'
  },
  {
    sql_phase: 'Get Token Time',
    mean: 'Get_token_time:total.values.mean',
    proportion: 'Database_time:by_phase.values.proportion#Get_token_time:total'
  },
  {
    sql_phase: 'Parse Time',
    mean: 'Parse_time:total.values.mean',
    proportion: 'Database_time:by_phase.values.proportion#Parse_time:total'
  },
  {
    sql_phase: 'Compile Time',
    mean: 'Compile_time:total.values.mean',
    proportion: 'Database_time:by_phase.values.proportion#Compile_time:total'
  },
  {
    sql_phase: 'Execute Time',
    mean: 'Execute_time:total.values.mean',
    proportion: 'Database_time:by_phase.values.proportion#Execute_time:total'
  }
]

interface DBTimeByKVRequestData {
  request_type: string
  mean: string | ColumnComponent
}

export const dbtimeByKVRequestData: DBTimeByKVRequestData[] = [
  {
    request_type: 'Execute Time(total)',
    mean: 'Execute_time:total.values.mean'
  },
  {
    request_type: 'TSO Wait(Total)',
    mean: 'Wait_start_TSO_time:total.values.mean'
  },
  {
    request_type: 'SQL Type(Top 5)',
    mean: {
      __component__: TopN(5, 'SQL_execute_time:by_type', ['proportion'])
    }
  }
]
